<template>
  <div class="item-rating">
    <div class="product-stars mini-stars">
      <div class="product-star-container half-star" v-if="(rating - fullStars) != 0">
        <div class="product-star">&nbsp;</div>
      </div>
      <div class="product-star-container" v-for="i in fullStars">
        <div class="product-star">&nbsp;</div>
      </div>
    </div>
    <div class="customer-rating" title="Bewertung durch Kunden" v-if="product.ratings_count > 0">
      {{product.rating}}/5 |  {{product.ratings_count}} Bewertungen
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    }
  },
  computed: {
    rating(){
      return this.product.rating
    },
    fullStars(){
      return Math.floor(this.rating)
    }

  }
}
</script>
